import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import wtyReportApi from "../../services/warrantyReportAxios";

const initialState = {
    searchedPin: String(''),
    searchedDealer: String(''),
    warrantyList: [],
    loading: false,
    error: null
}

export const getWarrantyInfo = createAsyncThunk(
    'warrantyList/getWarranty', async (searchObject) => {
        const warrantySearchApiUrl = '/warranty/getWarrantyDetails';

        try {
            const response = await wtyReportApi.get(warrantySearchApiUrl, searchObject);
            if (response.status !== 200) {
                new Error("Error occurred while fetching the warranty information.")
            }
            return await response.data;
        } catch (error) {

        }
    }
)

export const WarrantySearchSlice = createSlice({
    name: 'warrantyList',
    initialState,
    reducers: {
        resetWarrantyList: () => initialState
    },
    extraReducers(builder) {
        builder
            .addCase(getWarrantyInfo.pending, (state) => {
                state.loading = true;
                state.warrantyList = [];
            })
            .addCase(getWarrantyInfo.rejected, (state) => {
                state.loading = false;
                state.warrantyList = [];
            })
            .addCase(getWarrantyInfo.fulfilled, (state, action) => {
                state.loading = false;
                state.warrantyList = action.payload;
            })
    }
})


export const {resetWarrantyList} = WarrantySearchSlice.actions;

export const warrantyList = (state) => state.warrantyList.warrantyList;

export const warrantyListLoading = (state) => state.warrantyList.loading;

export default WarrantySearchSlice.reducer;